var map = {
	"./amcor.png": 222,
	"./assa.png": 223,
	"./avon.png": 224,
	"./bacardi.png": 225,
	"./cashcollector.png": 226,
	"./cepas.png": 227,
	"./darc.png": 228,
	"./edesur.png": 229,
	"./etil.png": 230,
	"./greeneat.png": 231,
	"./iting.png": 232,
	"./maynar.png": 233,
	"./mcr.png": 234,
	"./neomix.png": 235,
	"./panamerican.png": 236,
	"./redlink.png": 237,
	"./sabores.png": 238,
	"./sanjuan.png": 239,
	"./skf.png": 240,
	"./teaconnection.png": 241,
	"./unilever.png": 242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 221;